import { Box } from '@palmetto/palmetto-components';

import { useAppSelector } from './hooks/useAppSelector';

export const ServiceUnavailableBanner = () => {
  const { showServiceUnavailableBanner } = useAppSelector((state) => state.serviceStatus);

  if (showServiceUnavailableBanner) {
    return (
      <Box background="danger" padding="md" role="alert">
        The service is temporarily unavailable. Please try again in a moment.
      </Box>
    );
  }

  return null;
};
